import { render, staticRenderFns } from "./subgroup.vue?vue&type=template&id=2871842d&"
import script from "./subgroup.vue?vue&type=script&lang=js&"
export * from "./subgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports